// This icon file is generated automatically.
var PCloudOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.68 5.54a5 5 0 00-9.35 0 3.12 3.12 0 00.8 6.15h7.75a3.12 3.12 0 00.8-6.15zm.57 4.4c-.37.36-.86.56-1.37.56H3.12A1.92 1.92 0 011.2 8.56 1.92 1.92 0 012.63 6.7l.6-.16.2-.57A3.76 3.76 0 014.83 4.2a3.78 3.78 0 015.19.78c.24.3.42.64.56 1l.21.56.6.16a1.94 1.94 0 01.87 3.24z", "fill-rule": "nonzero" } }] }, "name": "p-cloud", "theme": "outlined" };
export default PCloudOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCloudOutlined.js
// module id = 3290
// module chunks = 0